/**
 * A drop item's picture. A masterclass shows its own cover video's frame,
 * looked up now: the item's snapshot keeps the picture it had when it was
 * added to the drop, which for an older drop can be the generated graphic
 * (Coleman, 2026-10-22: "I thought we were using a thumbnail from a video").
 * Everything else uses its snapshot.
 */
import { MASTERCLASS_COVERS, masterclassCover } from "../masterclass/masterclassCovers";

export function itemThumb(it) {
  if (!it) return null;
  if (it.item_type === "masterclass" && MASTERCLASS_COVERS[it.item_ref]) {
    return masterclassCover({ moduleKey: it.item_ref })[0] || it.snapshot?.thumb || null;
  }
  return it.snapshot?.thumb || null;
}
